var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }